import React, { useContext } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { LoginContext } from "../../Contexts/LoginContext";
import { showToast } from "../../Components/utils/ShowToast";
import Loader from "../../Components/utils/Loader";

function AdminLogin() {

    let [email, setEmail] = React.useState("");
    let [password, setPassword] = React.useState("");
    let [passwordHidden, setPasswordHidden] = React.useState(true);
    const navigate = useNavigate();
    const { adminLogin } = useContext(LoginContext);
    let [isLoading, setIsLoading] = React.useState(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/admins/admin/login`, { email, password })
            if (response.data.success) {
                adminLogin(response.data.token)
                navigate("/chwi-admin/dashboard")
                showToast("LoggedIn Successfully!", "success")
            }
            else
            showToast("Something went wrong!", "error")
        }
        catch (e) {
            showToast(e?.response?.data?.error || "Something went wrong!", "error" )
        }
        finally {
            setIsLoading(false);
          }
    }

    return (
        <div className='adminLoginDiv'>

            {isLoading && <Loader type="checkmate" />}

            <div className='adminLoginContent'>

                <form className="form" onSubmit={handleFormSubmit}>

                    <h2 className="primaryHeading">LogIn to <span>Admin</span> Panel</h2>
                    <div className="horizontalLine"></div>

                    <div className='inputDiv'>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            name='email'
                            className='inputField'
                            placeholder='Enter Email Address'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className='inputDiv'>
                        <div className="passwordFieldUpper">
                            <label htmlFor="password">Password</label>
                            <div className='hidePasswordBtn'
                                onClick={() => setPasswordHidden((oldValue) => !oldValue)}
                            >
                                <i className={passwordHidden ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}></i>
                            </div>
                        </div>
                        <input
                            type={passwordHidden ? "password" : "text"}
                            name='password'
                            className='inputField'
                            placeholder='Enter your password'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {/* <Link className='forgotPasswordBtn'>Forgot Password?</Link> */}
                    </div>

                    <button type='submit' className='primaryBtn'>Login</button>

                </form>

            </div>
        </div>
    )
}

export default AdminLogin